import GoogleReCAPTCHA from 'react-google-recaptcha';

declare global {
  interface Window {
    recaptchaOptions: {
      useRecaptchaNet: boolean;
    };
  }
}

if (typeof window !== 'undefined') {
  window.recaptchaOptions = {
    useRecaptchaNet: true,
  };
}

export const ReCAPTCHA = GoogleReCAPTCHA;
